
import * as Components from "./Taron"

export default function getCustomComponent () {
  return Components
}

export function getShopId () {
  return "taron"
}

